const moment = require("moment-timezone");
import axios from "axios";
import rulesConstant from "../constants/rules.constant";
import customerModal from "./customer.modal";
import { firebaseConfig } from "./firebase";
export function getDate() {
  return moment()
    .tz("America/Los_Angeles")
    .format("YYYY-MM-DDTHH:mm:ss");
}
export function getDateOnly() {
  return moment()
    .tz("America/Los_Angeles")
    .format("YYYY-MM-DD");
}
export function firstUpperCase(val) {
  val = val.toLowerCase();
  return val.charAt(0).toUpperCase() + val.slice(1);
}
export function resizeFile(file) {
  return new Promise((resolve, reject) => {
    const MAX_WIDTH = 320;
    const MAX_HEIGHT = 180;
    const MIME_TYPE = "image/jpeg";
    const QUALITY = 1;
    const blobURL = URL.createObjectURL(file);
    const img = new Image();
    img.src = blobURL;
    img.onerror = function(err) {
      reject(err);
    };
    img.onload = function() {
      const [newWidth, newHeight] = calculateSize(img, MAX_WIDTH, MAX_HEIGHT);
      const canvas = document.createElement("canvas");
      canvas.width = newWidth;
      canvas.height = newHeight;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, newWidth, newHeight);
      canvas.toBlob(
        (blob) => {
          displayInfo("Original file", file);
          displayInfo("Compressed file", blob);
        },
        MIME_TYPE,
        QUALITY
      );
      var dataURL = canvas.toDataURL("image/jpeg");
      resolve(dataURL);
    };
  });

  function calculateSize(img, maxWidth, maxHeight) {
    let width = img.width;
    let height = img.height;

    // calculate the width and height, constraining the proportions
    if (width > height) {
      if (width > maxWidth) {
        height = Math.round((height * maxWidth) / width);
        width = maxWidth;
      }
    } else {
      if (height > maxHeight) {
        width = Math.round((width * maxHeight) / height);
        height = maxHeight;
      }
    }
    return [width, height];
  }

  function displayInfo(label, file) {
    console.log(`${label} - ${readableBytes(file.size)}`);
  }

  function readableBytes(bytes) {
    const i = Math.floor(Math.log(bytes) / Math.log(1024)),
      sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    return (bytes / Math.pow(1024, i)).toFixed(2) + " " + sizes[i];
  }
}
export function formatDate(date) {
  if (date)
    return moment
      .tz(date, "America/Los_Angeles")
      .local()
      .format("MM/DD/YYYY hh:mm a");
  return "";
}

export function formatDateTime(date) {
  if (date)
    return moment(date)
      .local()
      .format("MM/DD/YYYY hh:mm a");
  return "";
}
export function getDateTime(date) {
  if (date)
    return moment
      .tz(date, "America/Los_Angeles")
      .local()
      .format("YYYY-MM-DDTHH:mm:ss");
  return "";
}
export function formatDateOnly(date) {
  if (date) return moment(date).format("MM/DD/YYYY");
  return "";
}
export function getStart(date) {
  return moment
    .tz(date, "America/Los_Angeles")
    .startOf("day")
    .format("YYYY-MM-DDTHH:mm:ss");
}
export function getEnd(date) {
  return moment
    .tz(date, "America/Los_Angeles")
    .endOf("day")
    .format("YYYY-MM-DDTHH:mm:ss");
}
export function getRawDate(date) {
  if (!date) moment.tz(date, "America/Los_Angeles");
  return moment.tz(date, "America/Los_Angeles");
}

export function formatPhone(phone) {
  if (!phone) return null;

  const cleaned = String(phone).replace(/\D/g, "");

  // Case 1: Legacy 10-digit US number
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }

  // Case 2: 11 or 12 digits (with country code)
  if (cleaned.length > 10 && cleaned.length <= 12) {
    const local = cleaned.slice(-10); // last 10 digits
    const country = cleaned.slice(0, cleaned.length - 10); // prefix
    return `+${country} (${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6)}`;
  }

  // Invalid / unexpected case
  return phone;
}

export function formatZip(val) {
  if (val && val.split("/").length == 3) {
    let split = val.split("/");
    val = split[0] + "/" + split[1];
  }
  return val;
}

export function formatMessage({
  message,
  fields,
  options,
  template_name,
  job_number,
  unknownFields,
  isTech,
  quote_number
}) {
  let $ = window.$;
  let doc = document.createElement("div");
  doc.innerHTML = message;
  fields.Job_Type = template_name;
  fields.Job_Number = job_number || quote_number;
  unknownFields = unknownFields || {};
  options = options || {};
  $(doc)
    .find("label")
    .each((i, item) => {
      let id = $(item).attr("data-id");
      let val = "";
      if (fields[id] != undefined) {
        val = fields[id];
        if (id == customerModal.PHONE) {
          val = formatPhone(val) || val;
        }
        if (options[id]) {
          val = options[id];
        }
      } else if (unknownFields[id] != undefined) {
        val = unknownFields[id];
      }
      if (isTech) {
        $(item).replaceWith(
          `<a href='${id}' data-id='${id}' target="_blank">${val}</a>`
        );
      } else {
        $(item).html(val);
      }
    });
  return doc.innerHTML;
}
export function formatMessageText({ message, fields, options }) {
  let $ = window.$;
  let doc = document.createElement("div");
  doc.innerHTML = message
    .split("<br>")
    .join("\n")
    .split("<br/>")
    .join("\n");
  options = options || {};
  $(doc)
    .find("label")
    .each((i, item) => {
      let id = $(item).attr("data-id");
      let val = "";
      if (fields[id] != undefined) {
        val = fields[id];
        if (id == customerModal.PHONE) {
          val = formatPhone(val);
        }
        if (options[id]) {
          val = options[id];
        }
      }
      $(item).html(val);
    });
  return doc.textContent.replace(/&nbsp;/g, " ");
}

export const getFormDoc = (form) => {
  let doc = {};
  Object.keys(form).forEach((key) => {
    if (form[key] == undefined) {
      doc[key] = "";
    } else {
      doc[key] = form[key];
    }
  });
  return doc;
};
export function getNormalDateTime(date) {
  if (date) return moment(date).format("YYYY-MM-DDTHH:mm:ss");
  return "";
}
export function shortenLink(url) {
  return axios.post(
    `https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=${firebaseConfig.apiKey}`,
    {
      longDynamicLink: `${firebaseConfig.dynamicLink}/?link=${url}`,
      suffix: {
        option: "SHORT",
      },
    }
  );
}
export const exportJSON = (json, name) => {
  var dataStr =
    "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(json));
  var dlAnchorElem = document.createElement("a");
  dlAnchorElem.setAttribute("href", dataStr);
  dlAnchorElem.setAttribute("download", name + ".json");
  dlAnchorElem.click();
};
export const getAppointmentWindow = (data) => {
  let { scheduled_at, schedule_end_at } = data;
  let msg = "";
  if (scheduled_at) {
    let start = scheduled_at;
    start = moment(start).format("MM/DD/YYYY hh:mm a");
    if (schedule_end_at) {
      let end = moment(schedule_end_at, "HH:mm").format("hh:mm a");
      msg = `${start} to ${end}`;
    } else {
      msg = start;
    }
  }
  return msg;
};

export function getRules(rules) {
  if (!rules) return [];
  rules = rules.split("|");
  let list = [];
  rules.forEach((rule) => {
    if (rulesConstant[rule]) list.push(rulesConstant[rule]);
  });
  return list;
}
